import { useMemo } from "react";
import { ListFormatter, TextFormatter } from "../muiTableHelper";
import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { DeleteOutline } from "@mui/icons-material";

export const SourcesListColumns = ({ setEditData, setShowModal, deleteSource }) => {
  return useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.name,
          });
        },
      },
      {
        accessorKey: "sites",
        header: "Sites",
        Cell: ({ row }) => {
          return ListFormatter(row.original.sites, "name");
        },
      },
      {
        accessorKey: "actions",
        header: "Actions",
        Cell: ({ row }) => {
          return (
            <>
              <Box flexDirection={"row" } display="flex" gap={1}>
                <Box>
                  <IconButton
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setEditData(row.original);
                      setShowModal(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Box>
                <Box>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      deleteSource(row.original);
                    }}
                  >
                    <DeleteOutline />
                  </IconButton>
                </Box>
              </Box>
            </>
          );
        },
      },
    ],
    [setEditData, setShowModal],
  );
};

export default SourcesListColumns;
